import UserDetails from "./Details"

export default UserDetails;